import axios from "axios";

/**
 * Registra el sí/no del cliente sobre un reporte que ya quedó aplicado.
 */
export const responderSubido = (ticketId, respuesta, headersToken) =>
  axios
    .post("soporte/responderSubido", { ticketId, respuesta }, { headers: headersToken })
    .then((res) => ({ ok: res.data?.success === 2, message: res.data?.message }))
    .catch(() => ({ ok: false, message: "Revisa tu conexión e intenta de nuevo." }));

export default responderSubido;
